import React, { useEffect, useRef, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import notificationSound from "../assets/audio/NotificationSound.mp3";

// function Alert_popup({ fromFbMetaLeadAd, isAvailable }) {
function Alert_popup() {
  const [showToast, setShowToast] = useState(true);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!showToast) {
      const timer = setTimeout(() => {
        setShowToast(true);
      }, 180000); // 300000 ms = 5 minutes
      return () => clearTimeout(timer); // Clear timeout if dependencies change
    }
  }, [showToast]);

  useEffect(() => {
    if (showToast && audioRef.current) {
      audioRef.current.play(); // Play the audio when showToast is true
      const audioTimer = setTimeout(() => {
        audioRef.current.pause();
      }, 5000);
      return () => clearTimeout(audioTimer);
    }
  }, [showToast]);

  const handleClose = () => {
    setShowToast(false);
  };

  return (
    <>
      {showToast && (
        <>
          <div
            className="position-fixed bottom-0 end-0 p-3 "
            style={{ zIndex: 11 }}
          >
            <div
              id="liveToast"
              className={`toast bg-dark text-light ${
                showToast ? "show" : "hide"
              }`}
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
            >
              <div className="toast-header">
                {/* {/ <img src="..." className="rounded me-2" alt="..." /> /} */}
                <strong className="me-auto text-danger">Alert</strong>
                {/* <small>11 mins ago</small> */}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="toast"
                  aria-label="Close"
                  onClick={handleClose}
                  //   style={{ color: "red", borderColor: "red" }}
                ></button>
              </div>
              <div className="toast-body">
                <b>Meta Lead Arrived.</b>
              </div>
            </div>
          </div>
          <audio ref={audioRef} src={notificationSound} />
        </>
      )}
    </>
  );
}

export default Alert_popup;
